import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexAccordion',
  setup(__props) {

const SimpleAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/SimpleAccordion.vue"))
const FlushAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/FlushAccordion.vue"))
const MultipleAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/MultipleAccordion.vue"))
const IconsAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/IconsAccordion.vue"))
const OutlineAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/OutlineAccordion.vue"))
const HorizontalAccordion = defineAsyncComponent(() => import("@/components/theme/uikits/accordion/HorizontalAccordion.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(SimpleAccordion)),
      _createVNode(_unref(FlushAccordion)),
      _createVNode(_unref(MultipleAccordion)),
      _createVNode(_unref(IconsAccordion)),
      _createVNode(_unref(OutlineAccordion)),
      _createVNode(_unref(HorizontalAccordion))
    ])
  ]))
}
}

})